<template>
  <div style="height: 100%;overflow:scroll;">
    <div v-loading='loading' class='calendar-container'>
      <div class='table-background'>
        <span class='background-date'>{{ calendarMonth }}</span>
      </div>
      <table ref='calendarTable' cellspacing='0' cellpadding='0' class='el-calendar-table'>
        <thead ref='calendarThead'>
          <th class='week'>周一</th>
          <th class='week'>周二</th>
          <th class='week'>周三</th>
          <th class='week'>周四</th>
          <th class='week'>周五</th>
          <th class='week weekend'>周六</th>
          <th class='week weekend'>周日</th>
        </thead>
        <tbody>
          <tr  v-for='(row,k)  in calendarData' :key='k' :style='rowStyle' @dragover='allowDrop'>
            <td :class="[item.class_name, row.show_date?'week':'']"
                @drop='dragend(item,j,k)' v-for='(item,j)  in row.weekDays'
                :key='`${k}_${j}`'
            >
              <div class='calendar-panel'>
                <div class='calendar-body'>
                  <div class='calendar-background'>
                    <span v-if='item.fullDate' :class="['dates']">
                      {{ item.num }}
                    </span>
                    <span v-else class='dates' style='color: #C0C4CC'>{{ item.num }}</span>
                  </div>
                  <div class='calendar-content'>
                    <div v-if='item.fullDate'>
                      <CalendarPanel :platforms='platforms' @handleDrag='handleDrag' :item='item' :show-limit='true'
                                     :limit-value='showLimit' @handleCmd='handleCmd'
                      />
                    </div>
                  </div>
                </div>

                <div class=' show-more' v-if='item.data&&item.data.length>showLimit'>
                  <el-popover
                    placement='right'
                    @show="handleExpand(true)"
                    @hide="handleExpand(false)"
                    width='300'
                    trigger='click'>
                    <div>
                      <CalendarPanel :platforms='platforms' :item='item' :show-limit='false' @handleCmd='handleCmd' />
                    </div>
                    <el-button size='mini' type='text' slot='reference'
                               style='width: 100%;text-align: right;padding-right: 8px;padding-top: -40px'>

                      <i :class='isExpand?"el-icon-remove-outline":"el-icon-circle-plus"'
                         class='expand-icon font-24'></i>
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ContextmenuTop :menu-data='menuData' @change='handleAdd' />
  </div>
</template>

<script>

import ContextmenuTop from './ContextmenuTop'
import CalendarPanel from '@/pages/lb/kol/ScheduleCalendar/CalendarPanel'

export default {
  name: 'CalendarView',
  components: {CalendarPanel, ContextmenuTop},
  props: {
    LbType: {
      type: [Number, String],
      default() {
        return null
      }
    },
    searchCondition: {
      type: Object,
      default() {
        return {}
      }
    },
    progressStatusOptions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    // searchCondition: {
    //   deep: true,
    //   handler() {
    //     this.handleQuery()
    //   }
    // }
    calendarData: {
      handler() {
        this.$nextTick(() => {
          this.updateRowHeight()
        })
      }
    }
  },
  data() {
    return {
      loading: false,
      menuData: {
        visible: false,
        top: 0,
        left: 0
      },
      currentItem: {},
      editData: {},
      dragendTime: '',
      dragendWeek: '',
      dataList: [],
      platforms: [],
      windowHeight: window.innerHeight,
      isExpand: false,
      rowHeight: 0
    }
  },
  computed: {
    //本月的数据转为对象，对象的键为日期， date=>[data1,data2]
    dailyData() {
      const dataMap = {}
      this.dataList.forEach((item) => {
        const date = this.$utils.parseTime(item.date, '{y}-{m}-{d}')
        if (!dataMap[date])
          dataMap[date] = []
        dataMap[date].push(item)
      })
      return dataMap
    },
    calendarData() {
      const dataList = []
      if (this.searchCondition.ym) {
        //根据当前月份的第一天，计算出当月月份日历的数据
        const currentMonthFirstDay = `${this.searchCondition.ym}-01`
        const days = this.$utils.calcCalendarDates(currentMonthFirstDay)

        const daysArr = this.$utils.array_chunk(days, 7)
        for (const j in daysArr) {
          // eslint-disable-next-line
          let weekDays = daysArr[j]

          // 检查这一周是否有本月的日期
          const hasCurrentMonthDate = weekDays.some(item => {
            if (!item.fullDate) return false
            const dateMonth = new Date(item.fullDate).getMonth() + 1
            const currentMonth = parseInt(this.searchCondition.ym.split('-')[1])
            return dateMonth === currentMonth
          })

          // 如果没有本月的日期，就不添加这一行
          if (!hasCurrentMonthDate) {
            continue
          }

          // eslint-disable-next-line no-unused-vars
          weekDays.forEach((item) => {
            item.data = item.fullDate ? this.dailyData[this.$utils.parseTime(item.fullDate, '{y}-{m}-{d}')] : []
            // item.show_all = true
          })
          dataList.push({ hidden_row: false, show_date: true, weekDays: weekDays, week: j })
        }
      }
      return dataList
    },
    calendarMonth() {
      const date = this.searchCondition.ym.split('-')
      // let year = date[0]
      const month = Number(date[1])
      return month
    },
    // 根据屏幕高度返回显示限制
    showLimit() {
      if (this.windowHeight > 1900) {
        return 8
      } else if (this.windowHeight > 1150) {
        return 6
      } else {
        return 4
      }
    },
    rowStyle() {
      if (this.rowHeight > 0) {
        const MAX_ROW_HEIGHT = 150
        const height = Math.min(this.rowHeight, MAX_ROW_HEIGHT)
        return { height: height + 'px', maxHeight: MAX_ROW_HEIGHT + 'px' }
      }
      return {}
    }
  },
  created() {
    this.getPlatformAl()
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.$nextTick(() => {
      this.updateRowHeight()
    })
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {

    async getPlatformAl() {
      const { list } = await this.$api.getPlatformAll({ status: 1 })
      this.platforms = list
    },
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      if (this.searchCondition.ym) {
        condition.ym = this.searchCondition.ym
      }

      if (this.searchCondition.artist_id) {
        condition.artist_id = this.searchCondition.artist_id
      }
      if (this.searchCondition.progress_status) {
        condition.progress_status = this.searchCondition.progress_status
      }
      if (this.searchCondition.leader_id) {
        condition.leader_id = this.searchCondition.leader_id
      }
      if (this.searchCondition.leader_name) {
        condition.leader_name = this.searchCondition.leader_name
      }
      //区分选品类型
      if (this.LbType) {
        condition.type = this.LbType
      }
      return condition
    },
    async handleQuery() {
      this.loading = true
      // this.$notify.info('查询')
      setTimeout(async () => {
        const searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, { order: this.orderSort })
        const { list } = await this.$api.getLbScheduleMonthList(searchCondition)
        this.dataList = list
        this.loading = false

        this.$emit('update:total', Array.isArray(list) ? list.length : 0)

        this.$nextTick(() => {
          this.updateRowHeight()
        })
      }, 600)

    },

    allowDrop(ev) {
      ev.preventDefault()
    },
    async dragend(data, j, k) {
      this.dragendTime = data.fullDate
      this.dragendWeek = { data: data, index: j, week: k }
    },
    handleDrag(data) {
      this.editData = data
      this.editDrag()
    },
    async editDrag() {
      if (this.dragendTime) {
        this.editData.start_at = this.dragendTime
        const info = await this.$api.saveLbSchedule(this.editData)
        if (info) {
          this.$notify.success('修改直播排期日期成功')
        }
        this.$emit('dragEdit', true)
      } else {
        this.$message({
          type: 'info',
          message: '日期错误，请选择正确日期'
        })
      }
    },
    openMenu(e, item) {
      if (item.fullDate) {
        this.currentItem = item
        e.preventDefault()
        this.menuData = {
          visible: true,
          left: e.clientX,
          top: e.clientY
        }
        document.addEventListener('click', this.closeMenu)
      }
    },
    //右键菜单关闭
    closeMenu(e) {
      //未点击在 菜单上，则关闭
      if (e.target.className.indexOf('contextmenu__item') === -1) {
        this.menuData.visible = false
        document.removeEventListener('click', this.closeMenu)
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleAdd(cmd) {
      this.$emit('handleCmd', cmd, this.currentItem)
    },
    handleCmd(cmd, row) {
      this.$emit('handleCmd', cmd, row)
    },
    // 处理窗口大小变化
    handleResize() {
      // 更新窗口高度，触发计算属性重新计算
      this.windowHeight = window.innerHeight
      this.$nextTick(() => {
        this.updateRowHeight()
      })
    },
    updateRowHeight() {
      const table = this.$refs.calendarTable
      const thead = this.$refs.calendarThead
      const tbody = table ? table.querySelector('tbody') : null
      if (!table || !thead || this.calendarData.length === 0) {
        this.rowHeight = 0
        if (tbody) tbody.style.removeProperty('--row-height')
        return
      }
      const containerHeight = table.parentElement.clientHeight
      const theadHeight = thead.offsetHeight
      const available = containerHeight - theadHeight
      const MAX_ROW_HEIGHT = 150
      const raw = Math.floor(available / this.calendarData.length)
      const height = Math.min(raw, MAX_ROW_HEIGHT)
      this.rowHeight = height
      if (tbody) {
        tbody.style.setProperty('--row-height', height + 'px')
      }
    },
    handleExpand(value) {
      this.isExpand = value
    }
  }

}
</script>

<style lang='scss' scoped>
@import "../../style/main.scss";

.time_selection {
  width: 100%;
  height: 50px;
  //border: 1px solid red;

  .selected {
    //border: 1px solid red;
    width: 300px;
    text-align: center;
    margin: 0 auto;
    font-size: 26px;
    line-height: 50px;
    color: $--text-color-gray !important;

    > span {
      font-size: 26px;
      margin: 0 30px;
      user-select: none;
    }

    .time_selection_button {
      cursor: pointer;
    }
  }

  .show_status {
    //display: inline-block;
    width: 300px;
    //border: 1px solid red;
    float: right;
  }
}

.dates {
  vertical-align: middle;
  text-align: center;
  font-size: 100px;
  margin-top: 10px;
  display: block;
}


.calendar-panel {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  /*padding: 0;*/
}

.el-calendar-table {
  height: 100%;
  table-layout: fixed;
}

/*
 * 统一控制所有数据行高度。
 * 不在 tr 上设 height（table layout 下 tr 的 height 仅作为最小高度且 max-height 无效），
 * 改为在 tbody 上设 CSS 变量，td 直接使用变量值，确保所有行一致。
 */
.el-calendar-table tbody {
  --row-height: auto;
}

.el-calendar-table tbody td {
  height: var(--row-height) !important;
  min-height: var(--row-height) !important;
  max-height: var(--row-height) !important;
}

.calendar-header {
  background-color: $--color--white !important;
  text-align: center;
  color: $--text-color-gray !important;
}

.calendar-body {
  position: relative;
  background-color: #fff !important;
  width: 100%;
  flex: 1;
  min-height: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  vertical-align: middle;
  text-align: center;
  padding: 0;
}

.calendar-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  opacity: 0.1;
  pointer-events: none;
}

.calendar-background .dates {
  font-size: 80px;
  color: lighten(#262626, 30%);
  margin-top: 0;
}

.calendar-content {
  position: relative;
  z-index: 2;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.calendar-footer {
  /*background-color: #0C0C0C !important;*/
  /*color: #0C0C0C !important;*/
  line-height: 1;
  height: 22px;
  //border: 1px solid red;
  /*z-index: 10;*/
}

.show-more {
  position: absolute;
  bottom: 0;
  //width: 100%;
  cursor: pointer;
  right: 0;
  z-index: 10; /* 提高z-index确保按钮在最上层 */
  //background-color: rgba(255, 255, 255, 0.9); /* 添加半透明背景确保按钮可见 */
  /*border: #ff3176 1px dashed;*/
  /*background-color: #ff3176;*/
  opacity: 0.9;
  pointer-events: none; /* 让按钮本身不接收鼠标事件 */
}

.show-more .el-button {
  pointer-events: auto; /* 只有按钮本身接收鼠标事件 */
}

.table__row {
}
.week {
  color: $--color--black;
  background-color: $--calendar-bg;
  //font-size: 1.2em;
  //font-size: 18px;
}

.weekend {
  background-color: $--calendar-week-bg;
}

.show-all-btn:hover {
  background-color: #F56C6C;
  color: #fefefe;
  font-size: 14px;
  padding: 3px 10px;
  border-radius: 3px;
}

.el-calendar-table thead th {
  padding: 4px 0 !important;
}

.calendar-container {
  position: relative;
  height: 95%;
  width: 100%;
}

.table-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  z-index: 1;
  opacity: 0.3;
  pointer-events: none;
  padding-right: 10%;
}

.background-date {
  font-size: 90vh;
  color: lighten($--color--black, 90%);
  font-weight: bold;
  line-height: 1;
  margin-top: 0;
  display: flex;
  align-items: center;
  height: 100%;
}

.expand-icon {
  transition: all 0.3s ease-in-out;
  transform-origin: center;
  color: #fe3176;
}

.expand-icon:hover {
  transform: scale(1.1);
  color: #c70043;
}

.el-icon-circle-plus {
  transition: all 0.3s ease-in-out;
}

.el-icon-remove-outline {
  transition: all 0.3s ease-in-out;
  transform: rotate(45deg);
}

</style>
